module.exports = __webpack_public_path__ + "static/media/(LH)-Prata-07.9dd6b69b.jpg";